import styled from "styled-components";
import { ProgressText } from "./ProgressText";

export const BlockChainErrorText = styled(ProgressText)`
  opacity: 1;
  margin-left: auto;
  font-size: 12px;
  color: #ff38af;
`;